import clsx from "clsx";
import React from "react";

type Props = { className?: string };

const ModalDivider: React.FC<Props> = ({ className }) => {
  return <hr className={clsx("border-p border-dashed px-[3%]", className)} />;
};

export default ModalDivider;
